// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("bevellier_medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("bevellier_medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("bevellier_medium.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Bevellier';
  font-style: normal;
  font-weight: 500;

  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./node_modules/@hg/stylizator/dist/fonts/bevellier/bevellier.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;;EAEhB,4CAAgC;EAChC;;0DAE6C;AAC/C","sourcesContent":["@font-face {\n  font-family: 'Bevellier';\n  font-style: normal;\n  font-weight: 500;\n\n  src: url('bevellier_medium.eot');\n  src: url('bevellier_medium.eot') format('embedded-opentype'),\n    url('bevellier_medium.woff2') format('woff2'),\n    url('bevellier_medium.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
